import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import DescriptionField from '../../form-fields/upload/description'
import { CreationToolUploadContext } from '../manager'

const Description = styled(DescriptionField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadDescriptionField = ({ className, field, sourceId }: Props) => {
    const { uploadSources, updateUploadSource, description, setDescription } = useContext(CreationToolUploadContext)
    const [displayDescription, setDisplayDescription] = useState<string>('')

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && setDisplayDescription(source.description || '')
        } else {
            setDisplayDescription(description)
        }
    }, [uploadSources, sourceId, description])

    const onChange = (description: string) => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && updateUploadSource({ ...source, description })
        } else {
            setDescription(description)
        }
    }

    return (
        <Description
            {...{
                className,
                field,
                description: displayDescription,
                showDescriptionAsPlaceholder: !!sourceId,
                showInstructions: true,
                isBulk: uploadSources.length > 1 && !sourceId,
                onChange,
            }}
        />
    )
}

export default CreationUploadDescriptionField
